import { ProfessionService } from 'data/services';
import { ProfessionListServiceInterface } from 'domain/services';
import { makeHandleProfessionList } from 'main/factories/usecases/profession/remote-profession';

export const makeProfession = (): ProfessionListServiceInterface => {
  return new ProfessionService(makeHandleProfessionList());
};
